import { createI18n } from "vue-i18n";
import { vuetifyLocaleMap } from './vuetify-generated.js';

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/unplugin-vue-i18n`, which is integrated into Vite.
 * See: https://github.com/intlify/bundle-tools/tree/main/packages/unplugin-vue-i18n
 */
function loadLocaleMessages() {
  const modules = import.meta.glob("./**/*.json", { eager: true, import: "default" });
  const messages = {};
  for (const path in modules) {
    const match = path.match(/\/([A-Za-z0-9_-]+)\.json$/i);
    if (match) {
      const locale = match[1];
      messages[locale] = modules[path];
    }
  }
  // Integrate Vuetify translations
  for (const localeKey of Object.keys(messages)) {
    const base = localeKey.split('-')[0];
    const vuetifyMsg = vuetifyLocaleMap[localeKey] || vuetifyLocaleMap[base];
    if (vuetifyMsg) {
      messages[localeKey] = { $vuetify: vuetifyMsg, ...messages[localeKey] };
    }
  }
  return messages;
}

const dateTimeFormats = {
  en: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },
  },
  it: {
    short: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },
  },
};

export default createI18n({
  legacy: false,
  locale: localStorage.getItem('lang') || 'en',
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
  dateTimeFormats,
});
